import { render, staticRenderFns } from "./ColumnFilters.vue?vue&type=template&id=cb2b744e&scoped=true&"
import script from "./ColumnFilters.vue?vue&type=script&lang=js&"
export * from "./ColumnFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2b744e",
  null
  
)

export default component.exports